import React, { Component } from 'react';

class About extends Component {

	render() {
		return (
			<div>
				<h1>About</h1>
				This is the about page!!
			</div>
		)

	}

}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js